import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

const PriceTypeField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	return <FullInfoField label="priceTypeLabel" value={customerForFullInfo?.priceType} />;
};

export default PriceTypeField;
